import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Drawer } from '../Drawer';
import { useCoach } from '../../api/healthCoach/useCoach';
import { UserDashboardPage } from '../UserDashboard/UserDashboardPage';
import { DashboardPageStateProvider } from '../../hooks/useDashboardPageState';
import { Box, CloseIcon, Flex, Pressable, useTheme } from 'native-base';
import { Loader } from '../Loader';

export const DashboardDrawer = () => {
  const {
    colors: { secondary },
  } = useTheme();
  const navigate = useNavigate();
  const { fetchUser, loading: coachLoading, isAuthenticated } = useCoach();
  const { patient } = useParams();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const handlePhaseLink = useCallback(() => {
    navigate(`/user-details/${patient}`);
  }, [navigate, patient]);

  useEffect(() => {
    setLoading(true);

    async function fetchPatient() {
      const user = await fetchUser(patient);
      setUser(user);
      setLoading(false);
    }

    if (!coachLoading && isAuthenticated) {
      fetchPatient();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient]);

  if (!user) return null;

  const { first_name, last_name } = user;

  return (
    <Drawer
      header={`${first_name} ${last_name ? last_name[0] : ''}.`}
      showHeader={false}
      bgColor={secondary['500']}
    >
      {loading ? (
        <Box>
          <Loader loading={true} />
        </Box>
      ) : (
        <DashboardPageStateProvider patientId={patient}>
          <UserDashboardPage
            header={
              <Flex
                alignItems="end"
                flexDirection="rwo"
                pr={4}
                pt={4}
                backgroundColor={secondary['500']}
              >
                <Pressable
                  variant={'closer'}
                  onPress={() => {
                    navigate(`/hc-dashboard`);
                  }}
                >
                  <CloseIcon size="6" color="muted.100" />
                </Pressable>
              </Flex>
            }
            inDrawer={true}
            onPhaseLinkClick={handlePhaseLink}
            onPhaseDetailsClick={handlePhaseLink}
          />
        </DashboardPageStateProvider>
      )}
    </Drawer>
  );
};
